import request from '@/utils/request'

let CustomerApi = {
  /* 客户列表 */
  list(data, errorback) {
    return request._post('/supplier/order.customer/index', data, errorback)
  },
  /* 客户详情 */
  detail(data, errorback) {
    return request._post('/supplier/order.customer/detail', data, errorback)
  }
}

export default CustomerApi



// WEBPACK FOOTER //
// ./src/api/customer.js